<template>
    <div id="warranty_list">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div v-if="warrantyVal != undefined">
            <div class="internal-table-border">
                <vue-good-table
                    ref="listWarrantyTable"
                    mode="remote"
                    title="Warranty"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: true,
                        position: 'both',
                        perPage: 100,
                        perPageDropdown:[10,20,30,40,50,100,500],
                        dropdownAllowAll: false,
                    }"

                    :search-options="{
                    enabled: false,
                    }">

                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                <router-link v-if="canUpdate" title="Edit Warranty" class="glyphicon glyphicon-edit" v-bind:to="{name: 'WarrantyEdit',params:{id:props.row.id}}"></router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>

        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">Component Warranty List
                        <router-link v-if="canAdd" class="btn btn-success waves-effect pull-right" v-bind:to="{name: 'WarrantyCreate'}">Add</router-link>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container">
                            <div class="container">
                                <vue-good-table
                                    ref="listWarrantyTable"
                                    mode="remote"
                                    title="Warranty"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: true,
                                        position: 'both',
                                        perPage: 100,
                                        perPageDropdown:[10,20,30,40,50,100,500],
                                        dropdownAllowAll: false,
                                    }"

                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                                <router-link v-if="canUpdate" title="Edit Warranty" class="glyphicon glyphicon-edit" v-bind:to="{name: 'WarrantyEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>


                                </vue-good-table>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import EventBus from ".././event-bus";


import {commonMixins} from '../../mixins/commonMixins';
    export default {
        name: "WarrantyList",
        mixins:[commonMixins],
        props: {
            warrantyVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
             permissions: [],
            cantAccessPage: "",
            columns: [
                {
                    label: 'Component Name',
                    field: 'component',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Component", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warranty Code',
                    field: 'code',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warranty Description',
                    field: 'description',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Starting Point Value',
                    field: 'starting_point_value',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Starting Point Value", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warranty Period',
                    field: 'period',
                    filterable: true,
                    type : 'number',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Period", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Warranty Type',
                    field: 'warranty_type_id',
                    filterable: true,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Warranty Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                // {
                //     label: 'Actions',
                //     field: 'action',
                //     sortable: false,
                // },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 50
            },
            warranty_value: false,
            loading:false,
            assetId:"",
            canUpdate:false,
            canAdd:false
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_warranty') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_warranty') {
                            self.warranty_value = true;
                        }
                        if (permissions[i].name == 'add_warranty') {
                            self.canUpdate = true;
                            self.canAdd = true;
                        }
                    }
                }
            }
        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('warranty_opted');
        },
        mounted: function() {
            var self = this;
            this.$root.$on('warranty_opted', () => {
                var path = window.location.pathname;
                var asset = path.split("/");
                self.assetId = asset[3];
                self.warrantyVal = "loadList";
                self.flag = 'component_warranty';
                self.getPermissions();
                self.loadComponentWarranty();
            });
            //when component list directly call from url instead of in view page than call permission request
            if ( self.warrantyVal == undefined ) {
                self.getPermissions();
            }
        },
        methods: {
            WarrantyCreatePage(){
                var self = this;
                self.$router.push("/warranty/create");
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                if (this.firstLoad == 1){
                    this.loadComponentWarranty();
                }
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                if (this.firstLoad == 1){
                    this.loadComponentWarranty();
                }
            },

            onColumnFilter(params) {
                this.updateParams(params);
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.code || filters.description || filters.starting_point_value || filters.effective_date || filters.warranty_type_id || filters.period) {
                    this.loadComponentWarranty();
                }
            },
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                if (this.firstLoad == 1){
                    this.loadComponentWarranty();
                }
            },
            loadComponentWarranty() {
                var self = this;
                // if(self.warrantyVal == 'component_warranty'){

                //     var path = window.location.pathname;
                //     var asset = path.split("/");
                //     self.assetId = asset[3];
                //     self.flag = 'component_warranty';

                // }
                if( self.warrantyVal == 'dontLoadList' ){
                    return;
                }
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    asset_id:self.assetId,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/component_warranty/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            WarrantyDelete() {
                var data = this.$refs['listWarrantyTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listWarrantyTable'].selectedRows[i].id)
                }

                if (confirm('Are you sure that you want to delete this Warranty? ')) {
                    self.loading = true;
                    $("#deleteWarrantyBtn").val("Deleting ...");
                    $.ajax({
                        url: process.env.ROOT_API + "/warranty/delete",
                        type: "POST",
                        data: 'ids=' + use,
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            setTimeout(function () {
                            $(".alert-success").removeClass("show");
                                $(".alert-success").addClass("hide");
                            }, 10000);
                            setTimeout(function () {
                                $("#deleteWarrantyBtn").val("Delete");
                            }, 10000);
                            self.rows = data.content.row;
                            if (data.code == '200') {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.loadWarranty();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                            } else {
                                //redirect to login page if user not authenticated
                                if (jqXHR.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem('user_obj');
                                    localStorage.removeItem('tkn');

                                    self.$router.push("/");
                                }
                               self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/asset/ComponentWarranty.vue